import { render } from "./StudentFeedBack.vue?vue&type=template&id=8391281c"
import script from "./StudentFeedBack.vue?vue&type=script&lang=js"
export * from "./StudentFeedBack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__